import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { Navbar, Nav } from 'react-bootstrap';

function Header({ onLogout, isAuthenticated, menuData }) {
    return (
        <Navbar bg="primary" expand="lg" data-bs-theme="dark">
            <Container>
                <Navbar.Brand as={Link} to="/">KB</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        {menuData.map((item, index) => (
                            <Nav.Link as={Link} to={`/${item.name}`} key={index}>
                                {item.name}
                            </Nav.Link>
                        ))}

                        {/* Add Snippet and logout link only when user is authenticated */}
                        {isAuthenticated ? (
                            <>
                                <Nav.Link as={Link} to="/add-snippet">
                                    Add Snippet
                                </Nav.Link>

                                <Nav.Link onClick={onLogout}>
                                    Logout
                                </Nav.Link>
                            </>
                        ) : null}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
